import { Container, Row, Col, Image } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function ParticipantVenue() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Participant info"
        title="Venue"
        intro="EAC2027 will take place in Cankarjev dom, Slovenia’s largest cultural and congress centre located in the centre of Ljubljana."
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className="h1">Cankarjev dom</h2>

                <p className="info-meta">
                  Cultural and Congress Centre
                </p>

                <p>
                  <strong>Official address:</strong> Prešernova cesta 10, 1000 Ljubljana, Slovenia
                  <br />
                  <strong>Website:</strong>{' '}
                  <a href="https://www.cd-cc.si/en/congress" target="_blank" rel="noreferrer">
                    www.cd-cc.si/en/congress
                  </a>
                </p>

                <p>
                  <span class="text-marker">The largest Slovenian cultural and congress centre</span> features multiple and highly flexible conference
                  areas and exhibition spaces, with capacity up to 2,000 participants. Its state-of-the-art technical
                  equipment and highly experienced, professional and friendly staff ensure high-quality and memorable
                  events. Cankarjev dom is located in the city centre and can be reached on foot from all nearby hotels
                  and accommodations in less than 15 minutes.
                </p>

              <figure className="info-photo mb-0_">
                <Image
                  src="img/Cankarjev_dom.jpg"
                  alt="Cankarjev dom"
                  fluid
                />

                <figcaption>
                  <i className="bi bi-arrow-right-short" aria-hidden="true"></i>
                  <span>Cankarjev dom cultural and congress Centre.</span>
                </figcaption>
              </figure>

                <p>
                  While significant parts of Ljubljana’s old town were shaped by the famous Slovenian architect Jože Plečnik, it was his student Edvard Ravnikar — who also studied with Le Corbusier — that conceived
                  Cankarjev dom and the surrounding Trg Republike square with accompanying buildings. Cankarjev dom is
                  Ravnikar’s magnum opus: an <span class="text-marker">architectural gem clad in white marble</span>. Many contemporary architecture
                  aficionados will find parallels between Ravnikar’s Cankarjev dom and Alvar Aalto’s Finlandia
                  Convention Centre in Helsinki.
                </p>

                <p>
                  Cankarjev dom not only fosters culture, the arts and shared human heritage with great sensitivity, but
                  also shows deep concern for nature. Cankarjev dom can profess to be the pioneer of Slovenian urban
                  beekeeping: the first four beehives were installed on one of its rooftop terraces in spring 2011.
                </p>

                <Image
                  src="img/CD_entrance.jpg"
                  alt="Cankarjev dom congress centre"
                  fluid
                  rounded
                  className="my-4 info-image border"
                />

                
              </section>

              <section className="info-section">
                <h2>How to get to the venue</h2>

                <p>
                  The easiest way to reach the conference venue is to <span class="text-marker">walk from your accommodation</span>. From most hotels in
                  the city centre, it takes about 5–15 minutes.
                </p>

                <p>
                  You might <span class="text-marker">use shared bicycles through BicikeLJ</span>, with stations across the city. Bear in mind that the
                  closest station might have no bicycles available at the moment or may be full and unable to accept your
                  bicycle when you want to return it. The weekly cost is 1 €.
                </p>

                <p>
                  Several <span class="text-marker">city bus</span> lines stop close to Cankarjev dom. From the Ljubljana Main Bus/Train Station
                  (Kolodvor) or Bavarski dvor, the fastest option is to take one of the central lines — 2, 6, 9, 14, 18L,
                  or 27 — and get off at nearby stops such as Kongresni trg or Drama. From there, it is a short
                  3–5 minute walk to the venue.
                </p>
              </section>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}